import React, { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { Header } from './Header';
import { Footer } from './Footer';
import { MobileStickyCTA } from './MobileStickyCTA';
export function Layout() {
  const {
    pathname
  } = useLocation();
  // Scroll to top on route change
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return <div className="min-h-screen flex flex-col bg-white" data-id="element-124">
      <Header data-id="element-125" />
      <main className="flex-grow" data-id="element-126">
        <Outlet data-id="element-127" />
      </main>
      <Footer data-id="element-128" />
      <MobileStickyCTA data-id="element-129" />
    </div>;
}